import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from 'components/assets/img/logo.png';
import isWindow from 'components/common/helpers/isWindow';
import * as LAYOUT from 'components/utils/layoutTypes';
import { connect } from 'react-redux';
import { setUserLogout } from 'components/actions/authActions';
import includes from 'lodash/includes';
import classNames from 'classnames';
import withRouter from 'components/components/common/withRouter';
import AppLink from 'components/common/AppLink';
import TransHelper from 'components/common/translations/TransHelper';

const LOGGED = 'logged';
const NOT_LOGGED = 'not_logged';

const menuItems = [
  {
    id: '1',
    value: 'content.layout.sidebarAndHeader.dashboard',
    link: 'routes.url.dashboard',
    icon: 'calendar-alt',
    layoutType: LAYOUT.DASHBOARD,
    showPermissions: [LOGGED, NOT_LOGGED]
  },
  {
    id: '2',
    value: 'content.layout.sidebarAndHeader.booking',
    link: 'routes.url.booking',
    icon: 'plane',
    layoutType: LAYOUT.BOOKING,
    showPermissions: [LOGGED, NOT_LOGGED]
  },
  {
    id: '3',
    value: 'content.layout.sidebarAndHeader.myAccount',
    link: 'routes.url.account',
    icon: 'user',
    layoutType: LAYOUT.ACCOUNT,
    showPermissions: [LOGGED]
  },
  {
    id: '4',
    value: 'content.layout.sidebarAndHeader.help',
    link: 'routes.url.help',
    icon: 'life-ring',
    layoutType: LAYOUT.DASHBOARD,
    showPermissions: [LOGGED]
  },
];

class Sidebar extends Component {

  state = {
    isClient: false,
  }

  componentDidMount() {
    if (this.props.isLogged) {
      var date = new Date();
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      var yyyy = date.getFullYear();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      date = 'last update: ' + dd + '.' + mm + '.' + yyyy + ', ' + hours + ':' + minutes;
      document.getElementById('ver').setAttribute('title', date);
    }
  }

  checkTabPermission = (tabData) => {
    var userPermission = this.props.isLogged ? LOGGED : NOT_LOGGED;
    return includes(tabData.showPermissions, userPermission);
  }

  classForLink = (linkTrans) => {
    var locale = this.props.locale;
    var link = TransHelper.translateRoute(locale, linkTrans);
    var pathName = this.props.location.pathname;
    var pathArray = pathName.split('/');
    var pathArrayFirstEl = '/' + pathArray[1] + '/' + pathArray[2];

    var routeTrans = TransHelper.findRouteKey(
      this.props.locale,
      this.props.location.pathname
    );
    routeTrans = 'routes.url.' + routeTrans;

    var dashboardSidesUrl = [
      TransHelper.translateRoute(locale, 'routes.url.dashboard')
    ];
    var bookingSidesUrl = [
      TransHelper.translateRoute(locale, 'routes.url.booking')
    ];
    var accountSidesUrl = [
      TransHelper.translateRoute(locale, 'routes.url.account')
    ];
    var helpSidesUrl = [
      TransHelper.translateRoute(locale, 'routes.url.howItWorks'),
      TransHelper.translateRoute(locale, 'routes.url.faq'),
      TransHelper.translateRoute(locale, 'routes.url.prices'),
      TransHelper.translateRoute(locale, 'routes.url.contact'),
    ];
    var isActive = false;

    if (includes(dashboardSidesUrl, pathArrayFirstEl)) {
      if (link === TransHelper.translateRoute(locale, 'routes.url.dashboard')) {
        isActive = true;
      }
    } else if (includes(bookingSidesUrl, pathArrayFirstEl)) {
      if (link === TransHelper.translateRoute(locale, 'routes.url.booking')) {
        isActive = true;
      }
    } else if (includes(accountSidesUrl, pathArrayFirstEl)) {
      if (link === TransHelper.translateRoute(locale, 'routes.url.account')) {
        isActive = true;
      }
    } else if (includes(helpSidesUrl, pathArrayFirstEl)) {
      if (link === TransHelper.translateRoute(locale, 'routes.url.help')) {
        isActive = true;
      }
    }
    else {
      isActive = link === pathName;
    }

    return classNames(
      'menu__link',
      { 'menu__link--active': isActive }
    );
  }

  render() {
    if (!this.props.isLogged || !isWindow) {
      return null;
    }
    var logoLink = this.props.isLogged ? 'routes.url.dashboard' : '/';
    return (
      <aside className="sidebar">
        <div className="logo-wrap">
          <AppLink
            className="logo"
            title="PKS Oslo - Homepage"
            to={logoLink}
          >
            <img src={logo} alt="PKS Oslo" />
          </AppLink>
        </div>

        <div className="menu-wrap">
          <ul className="menu" role="navigation">
            {menuItems.map(menuItem => {
              if (this.checkTabPermission(menuItem)) {
                return (
                  <li key={`menu${menuItem.id}`} className="menu__item">
                    <AppLink
                      className={this.classForLink(menuItem.link)}
                      to={menuItem.link}
                    >
                      <FontAwesomeIcon
                        icon={['fas', `${menuItem.icon}`]}
                        size="lg"
                      />
                      <span>{TransHelper.translate(this.props.locale, menuItem.value)}</span>
                    </AppLink>
                  </li>
                )
              }
            })}

            {/* hide logout button */}
            {/*{this.props.isLogged &&
              <li className="menu__item">
                <Link
                  onClick={this.logoutUser}
                  to={""}
                  className="menu__link"
                >
                  <FontAwesomeIcon
                    icon={['fas', 'sign-out-alt']}
                    size="lg"
                  />
                  <span>Log out</span>
                </Link>
              </li>
            }*/}
          </ul>
        </div>

        <p className="sidebar__copyright" style={{ display: 'none' }}>
          © 2019 <AppLink to="routes.url.home">PKS Oslo</AppLink> - {' '}
          <span
            id="ver"
            className="version-api"
            title="last update: 04.01.2019"
          >
            v0.06
          </span> all&nbsp;rights&nbsp;reserved
        </p>
      </aside>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    locale: state.app.locale,
  }
}

export default withRouter(connect(mapStateToProps, { setUserLogout })(Sidebar));

